import { provide, ref } from '@nuxtjs/composition-api';


export default {
  __name: 'UiDisclosure',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const isOpen = ref(props.open);
const toggle = () => {
  isOpen.value = !isOpen.value;
};

provide('isOpen', isOpen);
provide('toggle', toggle);

return { __sfc: true,props, isOpen, toggle }
}

}